var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_1605_12466)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_1605_12466)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_1605_12466)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_12466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.707 28.707L33.414 32L36.707 35.293L35.293 36.707L32 33.414L28.707 36.707L27.293 35.293L30.586 32L27.293 28.707L28.707 27.293L32 30.586L35.293 27.293L36.707 28.707ZM44 32C44 38.617 38.617 44 32 44C25.383 44 20 38.617 20 32C20 25.383 25.383 20 32 20C38.617 20 44 25.383 44 32ZM42 32C42 26.486 37.514 22 32 22C26.486 22 22 26.486 22 32C22 37.514 26.486 42 32 42C37.514 42 42 37.514 42 32Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_12466",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_12466",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1605_12466",
    x1: 60,
    y1: 50.5,
    x2: -8.94069e-8,
    y2: -5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD374E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF495E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_12466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.6c61a6cdc8158f2ee15b2f3fa7dcb6ee.svg";
export { ForwardRef as ReactComponent };